import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useSearchParams } from 'react-router-dom-v5-compat'
import { onChangeLocationId } from 'slices/customer/customerDetailsSlice'
import { get } from 'utils/lodash'

export const useSearchAndFilter = apiRef => {
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams()

  const handleFilterButtonClick = useCallback(() => {
    apiRef.current.showFilterPanel()
  }, [apiRef])

  const handleResetLocations = useCallback(
    filterModel => {
      const searchValue = get(filterModel, 'quickFilterValues[0]', '')
      const activeFiltersCount = get(filterModel, 'items', []).length
      if (activeFiltersCount === 0 && !searchValue) {
        searchParams.delete('location')
        setSearchParams(searchParams, { replace: true })
        dispatch(onChangeLocationId(''))
      }
    },
    [searchParams, setSearchParams, dispatch]
  )

  return {
    handleFilterButtonClick,
    handleResetLocations,
  }
}
